import { createSlice } from "@reduxjs/toolkit";

const _sliceName = 'homeReadings';
const _initialState = {};

const HomeReadingSlice = createSlice({
    name: _sliceName,
    initialState: { ..._initialState },
    reducers: {
        setReading: (state, action) => {
            let homeId = action.payload.homeId;
            let reading = action.payload.reading;
            state[homeId] = reading;
        }
    },
});


export { HomeReadingSlice };